import axios from "axios";
import { authHeader } from "./utils";
import { LIST_COOPERATION, LIST_SITE } from "./types";

export const fetchCooperations = () => async (dispatch) => {
  const res = await axios.get("/api/dashboard/cooperation", {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: LIST_COOPERATION, payload: res.data });
};

export const fetchSites = () => async (dispatch) => {
  const res = await axios.get("/api/dashboard/site", {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: LIST_SITE, payload: res.data });
};
